import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-button-action-dialog',
    imports: [MatIconModule, MatButtonModule],
    templateUrl: './button-action-dialog.component.html',
    styleUrls: ['./button-action-dialog.component.css']
})
export class ButtonActionDialogComponent {
@Input() action!: string
@Input() disabled  = false

 }
